import type { PropsWithChildren } from 'react'
import { useEffect } from 'react'

import { sessionService } from '@/core/auth/session/session.service'
import { getStoredToken } from '@/core/auth/session/session.storage'
import { authService } from '@/features/auth/services/auth.service'

export function AuthProvider({ children }: PropsWithChildren) {
  useEffect(() => {
    // 1. Restore UI state from localStorage immediately (no flicker).
    sessionService.hydrateSession()

    // 2. Verify the session is still valid server-side via the BFF /me endpoint.
    //    If the cookie is valid, update the profile. If not, clear the session.
    authService.getMe().then((result) => {
      if (result) {
        sessionService.startSession(result.profile, result.expiresAtUtc)
      }
    })
  }, [])

  useEffect(() => {
    // Una pestaña en segundo plano puede pausar o retrasar los timers del
    // navegador. Al regresar, validamos la sesión real contra el backend para
    // no dejar al usuario en una pantalla protegida con un token vencido.
    const validateOnReturn = () => {
      if (document.visibilityState !== 'visible') return
      if (!getStoredToken()) return

      void authService.getMe().then((result) => {
        if (result) {
          sessionService.startSession(result.profile, result.expiresAtUtc)
        }
      })
    }

    window.addEventListener('focus', validateOnReturn)
    document.addEventListener('visibilitychange', validateOnReturn)

    return () => {
      window.removeEventListener('focus', validateOnReturn)
      document.removeEventListener('visibilitychange', validateOnReturn)
    }
  }, [])

  return <>{children}</>
}
